import { GetTimeFromTimestamp, MaterialAmount, MaterialAmountType } from '@dave/types';

export class MaterialAmountEntity {
    constructor(public Type: MaterialAmountType = null, public WarehouseMovementId: number = null, public MaterialId: number = null, public Amount: number = null, public CreatedAt: Date = null) {}

    public static EntityName = 'MaterialAmount';

    public Clone(override: Partial<MaterialAmountEntity> = {}): MaterialAmountEntity {
        const attr = { ...this, ...override };
        return Object.assign(new MaterialAmountEntity(), attr);
    }

    public GetId() {
        return this.MaterialId + '|' + this.WarehouseMovementId;
    }
}

export function MaterialAmountEntityFromBackend(res: MaterialAmount): MaterialAmountEntity {
    return new MaterialAmountEntity(res.Type, res.WarehouseMovementId && +res.WarehouseMovementId, +res.MaterialId, +res.Amount, res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt));
}
